import api from './api';
import types from './mutation-types';
import _ from 'lodash';
export default {
	/**commit mutations*/
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setSearchPopupParam_({ commit }, { key, value }) {
		commit(types.SEARCH_POPUP_PARAMS, { key, value });
	},
	setPprNoSearchParam_({ commit }, { key, value }) {
		commit(types.PPR_NO_SEARCH_POPUP, { key, value });
	},
	setPprNoPagingInfo_({ commit }, { key, value }) {
		commit(types.PPR_NO_PAGING_INFO, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	/**call API */
	async getCommCodes_({ commit, rootState }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType, rootState['commonStore'].user.plantCd);
			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	/**call API */
	async getGlimsCommCodes_({ commit }, { key, mode, spras, zecdgrp }) {
		try {
			const { header, body } = await api.getGlimsCommCodes(mode, spras, zecdgrp);
			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body.resultList });
			} else if (header.code === 3) {
				return error.header || error;
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	//ppr번호 찾기 팝업에서 조회버튼 클릭시
	getPprNoPopupList_({ commit, state }) {
		const { pprNoPopupSearch, pprNoPagingInfo } = state;
		return api
			.getPprNoPopupList({ pprNoPopupSearch, pprNoPagingInfo })
			.then(data => {
				if (data.header.code === 0) {
					const { pagingInfo, resultList } = data.body;
					//console.log('pagingInfo, resultList >>> ', pagingInfo, resultList);
					commit(types.DEFAULT_ASSIGN, { key: 'pprNoPagingInfo', value: pagingInfo });
					commit(types.DEFAULT_ASSIGN, { key: 'pprNoPopupList', value: resultList });
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				// throw error.header ? error.header : error;
				throw new Error(error.header.message || error);
			});
	},
	/**한번에 공통 코드 부르기 */
	async getCommCodesOnce_({ commit }) {
		try {
			function sortCommCdList(commCd, val) {
				const key = _.camelCase(commCd) + 'CdList';
				// const list = [];
				// val.length && val.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				commit(types.DEFAULT_ASSIGN, { key, value: val });
			}
			const { header, body } = await api.getCommCodesOnce();
			if (header.code === 0) {
				for (const [key, val] of Object.entries(body)) {
					sortCommCdList(key, val);
				}
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error?.header;
		}
	},
	//조회버튼 클릭시
	getPrtRptList_({ commit, state },{isAuth}) {
		const { searchParams, pagingInfo } = state;
		return api
			.getPrtRptList({ searchParams, pagingInfo,isAuth })
			.then(data => {
				if (data.header.code === 0) {
					const { pagingInfo, resultList, partCkuScrId, feTarget, ubiTarget } = data.body;
					commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
					commit(types.DEFAULT_ASSIGN, { key: 'resultList', value: resultList });
					commit(types.DEFAULT_ASSIGN, { key: 'partCkuScrId', value: partCkuScrId });
					data.header = { ...data.header, feTarget, ubiTarget };
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				// throw error.header ? error.header : error;
				throw new Error(error.header.message || error);
			});
	},

	//최초 popup 오픈시 데이터가 있으면 조회
	async getPrtRptInfo_({ commit, state }, params) {
		try {
			const data = await api.getPrtRptInfo(params);
			if (data.header.code === 0) {
				const { prtRptInfo, glimsFileList, partCkuScrId } = data.body;
				// commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'detailForm', value: prtRptInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'glimsFileList', value: glimsFileList });
				//console.log('glimsFileList >>> ', glimsFileList);
				commit(types.DEFAULT_ASSIGN, { key: 'partCkuScrId', value: partCkuScrId });
				// } else if (data.header.code === 3) {
			}
			if (data.header.code === 1) {
			}
			if (data.header.code === 2) {
			}
			if (data.header.code === 3) {
			}
			if (data.header.code === 4) {
			}
			if (data.header.code === 5) {
			}
			return data.header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},
	//최초 popup 오픈시 정보가 없을때 partGCd 값을 가지고오기 위해 조회
	async getPartMstInfo_({ commit, state }, params) {
		try {
			const data = await api.getPartMstInfo(params);
			if (data.header.code === 0) {
				const { partMstInfo, prtRptInfo, partCkuScrId } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'partMstInfo', value: partMstInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'detailForm', value: prtRptInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'partCkuScrId', value: partCkuScrId });
			}
			if (data.header.code === 1) {
			}
			if (data.header.code === 2) {
			}
			if (data.header.code === 3) {
			}
			if (data.header.code === 4) {
			}
			if (data.header.code === 5) {
			}
			return data.header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},

	//form영역에서 입력한 항목을 detailForm store에 세팅
	onChangeParam_({ commit }, payload) {
		commit(types.SET_FORM, payload);
	},

	// 입력한 Form데이터 저장
	async saveData_({ store, state }, data) {
		try {
			const pprNo = state.detailForm.pprNo;
			const response = await api.saveData(data, pprNo);
			return response.header;
		} catch (error) {
			// return error?.header;
			throw new Error(error.header.message || error);
		}
	},

	/*
	 * 팝업관련 함수 시작
	 */
	setPopupInit_({ commit }) {
		commit(types.POPUP_INIT);
		// commit(types.DETAIL_FORM, { key: 'altrPreFile', value: {} });
		// commit(types.DETAIL_FORM, { key: 'altrAftFile', value: {} });
		// commit(types.DETAIL_FORM, { key: 'altrPreFileDb', value: {} });
		// commit(types.DETAIL_FORM, { key: 'altrAftFileDb', value: {} });
	},
	setBadTypePopupInit_({ commit }) {
		commit(types.BAD_TYPE_POPUP_INIT);
	},
	setHistoryPopupInit_({ commit }) {
		commit(types.BAD_TYPE_POPUP_INIT);
	},

	/* 메일발송 */
	async sendMail_({ commit, state }, { sendData }) {
		try {
			const { header } = await api.sendMail({ sendData });
			return header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},

	/* 결함유형 코드목록 1Level */
	async getBadTypeCodeLv1List_({ state, commit }, param) {
		let dForm = state.detailForm;
		return await api
			.getBadTypeCodeLv1List(dForm)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, { key: 'badTypeLv1List', value: data.body.resultList });
					commit(types.DEFAULT_ASSIGN, { key: 'badTypeLv2List', value: [] });
					commit(types.DEFAULT_ASSIGN, { key: 'badTypeLv3List', value: [] });
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});

		// try {
		// 	let dForm = state.detailForm;
		// 	const { header, body } = await api.getBadTypeCodeLv1List(dForm);
		// 	if (header.code === 0) {
		// 		await commit(types.DEFAULT_ASSIGN, { key: 'badTypeLv1List', value: body.resultList });
		// 		await commit(types.DEFAULT_ASSIGN, { key: 'badTypeLv2List', value: [] });
		// 		await commit(types.DEFAULT_ASSIGN, { key: 'badTypeLv3List', value: [] });
		// 	} else if (header.code === 3) {
		// 		throw error.header ? error.header : error;
		// 	}
		// 	return header;
		// } catch (error) {
		// 	return error.header || error;
		// }
	},

	/* 결함유형 코드목록 2Level */
	async getBadTypeCodeLv2List_({ commit, state }, { code }) {
		try {
			let { partGCd } = state.detailForm;
			const { header, body } = await api.getBadTypeCodeLv2List({ code, partGCd });
			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key: 'badTypeLv2List', value: body.resultList });
				await commit(types.DEFAULT_ASSIGN, { key: 'badTypeLv3List', value: [] });
			} else if (header.code === 3) {
				throw error.header ? error.header : error;
			}
			return header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},

	/* 결함유형 코드목록 3Level */
	async getBadTypeCodeLv3List_({ commit, state }, { code }) {
		try {
			let { partGCd } = state.detailForm;
			const { header, body } = await api.getBadTypeCodeLv3List({ code, partGCd });
			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key: 'badTypeLv3List', value: body.resultList });
			} else if (header.code === 3) {
				throw error.header ? error.header : error;
			}
			return header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},
	//이미지 다운로드 관련
	async imgDownload_(store, params = { fileId, fileSeq }) {
		try {
			const response = await api.fileDownload(params);
			const filename = decodeURIComponent(response.headers.filename);
			const filetype = decodeURIComponent(filename.substring(filename.lastIndexOf('.') + 1));
			let url = '';
			if ('|JPG|PNG|GIF|'.indexOf(filetype.toUpperCase()) > -1)
				url = window.URL.createObjectURL(new Blob([response.data], { type: 'image/png' }));
			return { name: filename, url };
		} catch (error) {
			return error?.header;
		}
	},
	//이미지 다운로드 관련
	async fileDownload_(store, params = { fileId, fileSeq }) {
		try {
			const response = await api.fileDownload(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			return error?.header;
		}
	},
	//Glims 파일 다운로드 관련
	async fileDownloadGlims_(store, params = { origFileName, encodeFullName }) {
		try {
			const response = await api.fileDownloadGlims(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			return error?.header;
		}
	},
	async fileDownloadGlimsHmcErp_(store, params = { origFileName, encodeFullName,uploadPath }) {
		try {
			const response = await api.fileDownloadGlimsHmcErp(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			return error?.header;
		}
	},

	// 승인프로세스 로직
	async saveState_({ commit }, stateParams) {
		try {
			const { header, body } = await api.saveState(stateParams);
			header.glimsErrMsg = body.glimsErrMsg === undefined ? '' : body.glimsErrMsg;
			return header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},

	// 승인프로세스 로직
	async saveState2_({ commit }, { formData, pprNo, affrPrcsId, pgsStCd }) {
		try {
			const { header } = await api.saveState2({ formData, pprNo, affrPrcsId, pgsStCd });
			return header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},

	//불량보고서 삭제
	async deletePrtRpt_({ commit }, delParams) {
		try {
			const { header } = await api.deletePrtRpt(delParams);
			return header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},

	//회신
	async answer_({ commit }, { formData, pprNo }) {
		try {
			const { header } = await api.answer({ formData, pprNo });
			return header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},

	//개선이력 버튼 클릭시
	async getPrtRptHisList_({ commit, state }, { partNo, affrPrcsId }) {
		try {
			const { historyPagingInfo } = state;
			const data = await api.getPrtRptHisList({ historyPagingInfo, partNo, affrPrcsId });
			if (data.header.code === 0) {
				const { pagingInfo, resultList } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'historyPagingInfo', value: pagingInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'pprHistoryList', value: resultList });
			} else if (data.header.code === 3) {
				return error.header;
			}
			return data.header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},
	setHistoryPagingInfo_({ commit }, { key, value }) {
		commit(types.HISTORY_PAGING_INFO, { key, value });
	}
};
